import React from 'react';

const ExportIcon = () => (
  <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
    <path className="st0" d="M0,0h24v24H0V0z" fill="none" />
    <g>
      <path d="M7.1,7.2l1.4,1.4L11,6.1V14h2V6.1l2.5,2.5l1.4-1.4L12,2.3L7.1,7.2z" />
    </g>
    <g>
      <path d="M19,11.1h-2.7v2H19V19H5v-5.9h2.7v-2H5H3v2V19c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-5.9v-2H19z" />
    </g>
  </svg>
);

export default ExportIcon;
